import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const deleteReasonApi = createApi({
    reducerPath: 'deleteReasonApi',
    baseQuery: (fetchBaseQuery({
        // Delete reasons live on the old backend host.
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST_OLD}/api`, prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })),
    endpoints: (build) => ({
        getDeleteReasons: build.query({
            query() {
                return {
                    url: '/admin/delete-reasons/getAll',
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            // The endpoint answers with a `{ message }` object when none exist.
            transformResponse: (response) => (Array.isArray(response) ? response : []),
            providesTags: ['Delete Reasons']
        }),
        getDeleteReasonsByListingId: build.query({
            query(listing_id) {
                return {
                    url: `/admin/listings-delete-reasons/listing/${listing_id}`,
                    params: {},
                    method: 'GET',
                    headers: {}
                }
            },
            transformResponse: (response) => (Array.isArray(response) ? response : []),
            providesTags: ['Listing Delete Reasons']
        }),
        createDeleteReason: build.mutation({
            query: (data) => ({
                url: '/admin/delete-reasons/create',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Delete Reasons']
        }),
        deleteDeleteReason: build.mutation({
            query(id) {
                return {
                    url: `/admin/delete-reasons/delete/${id}`,
                    method: 'DELETE',
                }
            },
            invalidatesTags: ['Delete Reasons']
        }),
        updateDeleteReason: build.mutation({
            query({ id, data }) {
                return {
                    url: `/admin/delete-reasons/update/${id}`,
                    method: 'PUT',
                    body: data
                }
            },
            invalidatesTags: ['Delete Reasons']
        }),
    }),
});

export const {
    useLazyGetDeleteReasonsQuery,
    useGetDeleteReasonsQuery,
    useGetDeleteReasonsByListingIdQuery,
    useCreateDeleteReasonMutation,
    useDeleteDeleteReasonMutation,
    useUpdateDeleteReasonMutation
} = deleteReasonApi;
